import React from 'react';
import './AccordionItem.css';

export const AccordionItem = ({ title, text, handleToggle, index, isOpen }) =>
    <div className="accordion-item-container">
        <div className="accordion-item-title-wrapper" onClick={() => handleToggle(index)}>
            <div
                className="accordion-item-title"
                dangerouslySetInnerHTML={{ __html: title }}>
            </div>
            <div className={`accordion-title-arrow ${isOpen ? 'active' : ''}`}></div>
        </div>

        <div className={isOpen ? 'accordion-item-text active' : 'accordion-item-text'}>
            <p className="accordion-item-text__content" dangerouslySetInnerHTML={{ __html: text }}></p>
        </div>
    </div>;
